import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';

const DestinationSectionn = () => {
  return (
    <div className="destination-area position-relative overflow-hidden pb-5 mb-md-4 pt-0 pb-5">
      <div className="title-area text-center pb-md-5 pt-0">
       
      </div>
 <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <div className="title-area">
              <span className="sec-subtitle">
                Mumbai Airport Cab Routes
              </span>

              <h2 className="sec-title h1">
                Popular Cab Routes From Mumbai Airport
              </h2>

              <p className="sec-text text-dark" >
                Book affordable and comfortable airport transfers and
                outstation taxi services from Mumbai Airport to major cities
                and tourist destinations across Maharashtra and India.
              </p>
            </div>
          </div>
        </div>
      <Swiper
        spaceBetween={30}
        slidesPerView={1}
        breakpoints={{
          576: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
        }}
        effect="coverflow"
        coverflowEffect={{
          rotate: 0,
          stretch: 95,
          depth: 212,
          modifier: 1,
        }}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        loop={true}
        modules={[Autoplay, EffectCoverflow]}
        className="th-slider destination-slider slider-drag-wrap"
      >
        {[ // Array of destinations
          { name: "Mumbai", image: "/images/mumbai.webp" },
          { name: "Lonavala", image: "/images/lonavala.jpg" },
          { name: "Mahabaleshwar", image: "/images/maha.jpeg" },
          // { name: "Shirdi", image: "/images/shirdi.webp" },
          { name: "Trimbakeshwar", image: "/images/trimb.jpg" },
          { name: "Ashtavinayk Darshan", image: "/images/Ashtavinayk.png" },
          { name: "Konkan", image: "/images/konkan.jpg" },
          { name: "Kolhapur", image: "/images/kohlapurr.jpg" },
          { name: "Goa", image: "/images/goa.jpg" },
          { name: "khatushyam", image: "/images/khatushyam.png" },
        ].map((destination, index) => (
          <SwiperSlide key={index}>
            <div className="destination-box gsap-cursor">
              <div className="destination-img">
                <img src={destination.image} alt={destination.name} />
                <div className="destination-content">
                  <div className="media-left">
                    <h4 className="box-title">
                      <a href="#">{destination.name}</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default DestinationSectionn;
